import { Routes } from '@angular/router';
import { policyDetailsGuard } from './core/guards/policy-details.guard';
import { MsalGuard } from '@azure/msal-angular';
import { reportsGuard } from '@core/guards/reports.guard';
import { authSessionGuard } from '@core/guards/auth-session.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [authSessionGuard]
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/report/report.component').then(m => m.ReportComponent),
    canActivate: [authSessionGuard, MsalGuard, reportsGuard]
  },
  {
    path: 'policy-details',
    loadComponent: () =>
      import('./pages/policy-detail/policy-detail.component').then(m => m.PolicyDetailComponent),
    canActivate: [authSessionGuard, MsalGuard, policyDetailsGuard]
  }

];
